export default {
  data: () => ({
    outOfTime: false,
  }),
  methods: {
    startTimer() {
      let interval = setInterval(() => {
        this.time -= 1000;
        let min = Math.floor(this.time / (60 * 1000)),
            sec = Math.floor((this.time - (min * 60 * 1000)) / 1000);
        if (this.time <= 0) {
          this.timeText = 'Out of Time'
          clearInterval(interval);
          this.outOfTime = true;
        } else {
          this.timeText = `${min >= 10 ? min : '0' + min}:${sec >= 10 ? sec : '0' + sec}`;
        }
      }, 1000);
    },
    restart() {
      this.time = 1800000;
      this.outOfTime = false;
      this.startTimer();
    },
  },
}